import { render, staticRenderFns } from "./ProductSearchBrowse.vue?vue&type=template&id=3048baea"
import script from "./ProductSearchBrowse.vue?vue&type=script&lang=ts"
export * from "./ProductSearchBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports